import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Typography, Modal, Input, List, Collapse } from 'antd'
import {
  CaretRightOutlined,
  ExclamationCircleOutlined,
  SearchOutlined
} from '@ant-design/icons'
import styled from 'styled-components'
import { FlexSectionHeader } from '../style'
import CourseCard from '../../components/CourseCard'

import Spinner from '../../components/Spinner'

import {
  getAllCourses,
  deleteCourse,
  enroll,
  unEnroll
} from '../../reducers/courseReducer'

import { useHistory } from 'react-router-dom'

const { Title, Text } = Typography
const { confirm } = Modal

const PageHero = styled.div`
  background: white;
  border-radius: 16px;
  padding: 60px 40px;
  text-align: center;
  margin-bottom: 32px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.04);
  border: 1px solid #eaeaea;

  h1 {
    font-size: 2.2rem;
    font-weight: 700;
    color: hsl(210, 55%, 22%);
    margin-bottom: 16px;
  }
  p {
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 32px;
  }
`

const BigSearch = styled(Input.Search)`
  max-width: 600px;
  margin: 0 auto;
  .ant-input {
    height: 52px;
    font-size: 1.1rem;
    border-radius: 8px 0 0 8px !important;
    border: 1px solid #e0e0e0;
  }
  .ant-input-search-button {
    height: 52px !important;
    width: 64px !important;
    border-radius: 0 8px 8px 0 !important;
    background: hsl(33, 100%, 50%) !important;
    border-color: hsl(33, 100%, 50%) !important;
    svg {
      font-size: 22px;
    }
  }
  .ant-input-search-button:hover {
    background: hsl(33, 100%, 45%) !important;
  }
`

const Courses = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getAllCourses())
  }, [dispatch])

  const user = useSelector((state) => state.auth.user)
  const courses = useSelector((state) =>
    state.courses.data.filter((course) => course.status !== 'archived')
  )
  const loading = useSelector((state) => state.courses.loading)
  const history = useHistory()

  const [filter, setFilter] = useState('')

  const filteredCourses = courses?.filter((course) => {
    return course.name.toLowerCase().indexOf(filter.toLowerCase()) > -1
  })

  const removeCourse = (courseId) => {
    dispatch(deleteCourse(courseId))
  }

  const handleEnroll = (courseId, userId) => {
    dispatch(enroll(courseId, userId))
  }

  const handleUnenroll = (courseId, userId) => {
    dispatch(unEnroll(courseId, userId))
  }

  const handleSearch = (value) => {
    setFilter(value)
  }

  const confirmEnrolled = function (courseId, userId) {
    confirm({
      title: 'Do you Want to enroll in this course?',
      icon: <ExclamationCircleOutlined />,
      content: 'You have to enroll in the course to view its content',
      onOk() {
        handleEnroll(courseId, userId)
      },
      onCancel() {
        return
      }
    })
  }

  const handleCourseCardClick = (courseId, userId, userEnrolled) => {
    if (userEnrolled) history.push(`/app/course/${courseId}/modules`)
    else confirmEnrolled(courseId, userId)
  }

  if (loading) return <Spinner size="large" />

  return (
    <React.Fragment>
      <PageHero>
        <h1>Explore 4,000+ Premium Courses</h1>
        <p>
          Discover new skills, earn recognized certificates, and advance your
          career today.
        </p>
        <BigSearch
          allowClear
          onSearch={handleSearch}
          placeholder="What topic are you eager to explore today?"
          enterButton={<SearchOutlined />}
        />
      </PageHero>

      <div style={{ marginTop: 16 }}>
        <Collapse
          expandIcon={({ isActive }) => (
            <CaretRightOutlined rotate={isActive ? 90 : 0} />
          )}
          defaultActiveKey={['1']}
          ghost
        >
          <Collapse.Panel header={<Text strong>Public Courses</Text>} key="1">
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 1,
                md: 2,
                lg: 3,
                xl: 3,
                xxl: 5
              }}
              dataSource={filteredCourses}
              renderItem={(course) => (
                <List.Item>
                  <CourseCard
                    course={course}
                    removeCourse={() => removeCourse(course.id)}
                    handleEnroll={() => handleEnroll(course.id, user._id)}
                    handleUnenroll={() => handleUnenroll(course.id, user._id)}
                    onClick={() =>
                      handleCourseCardClick(
                        course.id,
                        user._id,
                        course.enrolled
                      )
                    }
                  />
                </List.Item>
              )}
            />
          </Collapse.Panel>
        </Collapse>
      </div>
    </React.Fragment>
  )
}

export default Courses
